import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '../icon-prop-types';
import { IconSizes } from '../icon-prop-types';

const TEST_ID = 'sort-icon-svg';

export const SortIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            data-testid={TEST_ID}
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <g className={fillStyles}>
                <path d="M7.25 3 4.176 6.69a.75.75 0 1 0 1.152.96L6.5 6.244v10.07c0 .38.336.687.75.687s.75-.307.75-.686V6.243L9.175 7.65a.75.75 0 1 0 1.152-.96L7.25 3zm11.423 13.348-1.173 1.41V7.684c0-.378-.336-.685-.75-.685-.415 0-.75.307-.75.685V17.757l-1.174-1.409a.75.75 0 0 0-1.153.96L16.75 21l3.076-3.692a.75.75 0 1 0-1.153-.96z" />
            </g>
        </svg>
    );
};
SortIcon.TEST_ID = TEST_ID;
